export default "__VITE_ASSET__Awiz$JCb__"